import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './CourseOutline.module.scss'

const CourseOutline = ({ certification }) => {
  const { t } = useTranslation()

  return (
    <section className={classes.card}>
      <span className={classes.label}>{t('portal.certification.details.outlineTitle')}</span>
      {certification.sections.map((section, index) => (
        <div key={section.id} className={classNames('d-flex align-items-center', classes.row)}>
          <span className={classes.number}>{index + 1}</span>
          <span className={classes.title}>{section.title}</span>
          <span className={classes.meta}>
            {t('portal.certification.details.lessons', { count: section.lessons.length })}
            {section.quiz && ` · ${t('portal.certification.details.quiz')}`}
          </span>
        </div>
      ))}
      {certification.finalQuiz && (
        <div className={classNames('d-flex align-items-center', classes.row)}>
          <span className={classes.number}><i className='fa fa-graduation-cap' aria-hidden='true' /></span>
          <span className={classes.title}>{t('portal.certification.item.finalExam')}</span>
          <span className={classes.meta}>{t('portal.certification.details.questions', { count: certification.finalQuiz.questions.length })}</span>
        </div>
      )}
    </section>
  )
}

CourseOutline.propTypes = {
  certification: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      lessons: PropTypes.array.isRequired,
      quiz: PropTypes.object,
    })).isRequired,
    finalQuiz: PropTypes.shape({ questions: PropTypes.array.isRequired }),
  }).isRequired,
}

export default CourseOutline
